import React from 'react';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { InstitutionNameInput } from '../../../../Profile/Accounts/Features/AccountPreferences/components/AccountForm/components/InstitutionNameInput/InstitutionNameInput';
import { InsuranceType } from '../../api/useInsuranceQuery';
import { AccountDescription } from '../components/AccountDescription/AccountDescription';
import { AccountOwnerSelect } from '../components/AccountOwnerSelect/AccountOwnerSelect';
import { DisabilityMonthlyBenefitAmount } from '../components/DisabilityMonthlyBenefitAmount/DisabilityMonthlyBenefitAmount';
import { IsBrokerOfRecord } from '../components/IsBrokerOfRecord/IsBrokerOfRecord';
import { CoverageType } from '../components/CoverageType/CoverageType';
import { DisabilityInsurancePolicyType } from '../components/DisabilityInsurancePolicyType/DisabilityInsurancePolicyType';
import { Premium } from '../components/Premium/Premium';
import { TimePeriod } from '../components/TimePeriod/TimePeriod';
import { TabsContent } from '../components/TabsContent/TabsContent';
import { InsuranceData } from '../../useInsurance';
import { FormProps } from '../../components/UpsertInsuranceModal/UpsertInsuranceModal.meta';
import { ManagementStyles } from '../components/ManagementStyles/ManagementStyles';
import { AssetBucketing } from '../components/AssetBucketing/AssetBucketing';

interface TabProps {
  data: InsuranceData;
}

export const Summary = ({ data }: TabProps) => {
  return (
    <Box display="flex" flexDirection="column" mt="16" css="gap: 16px">
      <InstitutionNameInput isInsurance />

      <AccountOwnerSelect data={data} insuranceType={InsuranceType.Disability} />

      <AccountDescription />

      <DisabilityMonthlyBenefitAmount />

      <ManagementStyles data={data} />

      <AssetBucketing data={data} />

      <IsBrokerOfRecord />
    </Box>
  );
};

export const PolicyDetails = ({ data }: TabProps) => {
  return (
    <Box display="flex" flexDirection="column" mt="16" css="gap: 16px">
      <CoverageType data={data} />

      <DisabilityInsurancePolicyType data={data} />

      <Premium />

      <TimePeriod
        label="Coverage Period"
        fieldName="DisabilityCoveragePeriod"
        options={data.Options.DisabilityCoveragePeriodTypeOptions}
      />

      <TimePeriod
        label="Elimination Period"
        fieldName="DisabilityEliminationPeriod"
        options={data.Options.DisabilityEliminationPeriodTypeOptions}
      />
    </Box>
  );
};

const tabs = [
  {
    name: 'Summary',
    Component: Summary,
  },
  {
    name: 'Policy Details',
    Component: PolicyDetails,
  },
];

export const DisabilityInsuranceForm = (props: FormProps) => {
  return <TabsContent tabs={tabs} {...props} />;
};
